import React, { useEffect, useState, useCallback } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	CircularProgress,
	DialogActions,
	Button
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';
import jwtService from '../../auth/store/actions/jwtService';
import * as UserActions from 'app/auth/store/actions/user.actions';
import { setLoginSuccess } from 'app/auth/store/actions';
import { getOidcParams } from '../util/openIdConnect';

import { useHistory } from 'react-router-dom';

const OidcCallbackHandler = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [loginError, setLoginError] = useState(null);
	const dispatch = useDispatch();
	const history = useHistory();

	const handleLogin = useCallback(async () => {
		const { code, state, codeVerifier, expectedState, configId, provider } = getOidcParams();

		if (!code || state !== expectedState || !codeVerifier || !configId) {
			setLoginError('Invalid or missing login parameters. Please try again.');
			setIsLoading(false);
			return;
		}
		history.replace(window.location.pathname);

		try {
			const token = await jwtService.signInForOidc({
				code,
				codeVerifier,
				configId,
				state,
				expectedState,
				provider
			});
			const { user } = decode(token);
			dispatch(UserActions.setUserData({ ...user, username: user.name }));
			dispatch(setLoginSuccess());
			history.replace('/');
		} catch (err) {
			console.error('Oidc login failed:', err);
			setLoginError(err?.message || 'Login failed. Please try again.');
			setIsLoading(false);
		}
	}, [dispatch]);

	useEffect(() => {
		handleLogin();
	}, [handleLogin]);

	const onClose = () => history.replace('/');

	return (
    <Dialog open fullWidth maxWidth="xs" onClose={onClose}>
      <DialogTitle>
        {isLoading ? 'Verifying Your Account' : 'Login Error'}
      </DialogTitle>

      <DialogContent dividers style={{ textAlign: 'center', padding: '24px 16px' }}>
        {isLoading ? (
          <>
            <CircularProgress />
            <Typography variant="body2" style={{ marginTop: 16 }}>
              Please wait while we complete your login...
            </Typography>
          </>
        ) : (
          <Typography variant="body2" color="error">
            {loginError || 'An unknown error occurred. Please try again.'}
          </Typography>
        )}
      </DialogContent>

      {!isLoading && (
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default OidcCallbackHandler;
